import styled from "styled-components";
import { FaGoogle } from "react-icons/fa";

export const LoginButton = styled.button`
    transition: filter 0.05s ease-in-out;

    &:hover {
        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.1);
    }
`;

export function GoogleLogin(props: {
    callbackFunction: (e: React.MouseEvent<HTMLButtonElement>) => void;
    buttonText: string;
}) {
    return (
        <LoginButton
            className="relative my-2 flex h-[36px] overflow-hidden rounded bg-[#f34132]"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                props.callbackFunction(e);
            }}
        >
            <div className="absolute bottom-0 left-0 top-0 flex h-full w-[45px] items-center justify-center bg-[#9e2d29]">
                <FaGoogle />
            </div>
            <div className="flex h-full w-full items-center justify-center text-sm">
                <p>{props.buttonText}</p>
            </div>
        </LoginButton>
    );
}
